import ImageOptimize from '@/components/ImageOptimize'
import NotFoundItem from '@/components/NotFound'
import ProductCard from '@/components/ProductCard'
import { useNotification } from '@/containers'
import { useFlashSale } from '@/containers/FlashSaleContainer'
import { Meta } from '@/layouts/Meta'
import { Main } from '@/templates/Main'
import type { Product } from '@/types'
import { getTranslate, setContext } from '@/utils/api-interceptors'
import { getFlashSaleSSR, getSaleRegion } from '@/utils/endpoint'
import { getCookies } from 'cookies-next'
import Link from 'next/link'
import type { GetServerSideProps, GetServerSidePropsContext } from 'next/types'

const FlashSalePage = () => {
  const { flashSale } = useFlashSale()
  const { systemConfig } = useNotification()

  const qtt =
    systemConfig?.imageQlt && systemConfig?.imageQlt != ''
      ? systemConfig?.imageQlt
      : 80
  const customStyle = {
    backgroundImage:
      flashSale?.customization?.backgroundImage &&
      `url(${flashSale?.customization?.backgroundImage}?format=webp&quality=${qtt})`,
    backgroundRepeat: flashSale?.customization?.backgroundImage && 'no-repeat',
    backgroundPosition:
      flashSale?.customization?.backgroundImage && 'top center',
    backgroundSize: flashSale?.customization?.backgroundImage && '100% auto',
  }
  return (
    <Main
      meta={
        <Meta
          title={getTranslate(flashSale?.name)}
          description={getTranslate(flashSale?.content)}
        />
      }
      bgColor={flashSale?.customization?.backgroundColor}
      bgImage={customStyle}
      dataHeader={getTranslate(flashSale?.name)}
      pageLayout=''
    >
      <section className='flash-sale wrapper min-h-[calc(100svh-60px)]'>
        {flashSale ? (
          <>
            {flashSale?.customization?.banner ? (
              <div className='banner mb-3 block w-full overflow-hidden'>
                {flashSale?.customization?.bannerLink ? (
                  <Link
                    href={flashSale?.customization?.bannerLink || ''}
                    className='block outline-none'
                  >
                    <ImageOptimize
                      width={1312}
                      height={400}
                      src={flashSale?.customization?.banner}
                      alt={getTranslate(flashSale.name)}
                      priority={true}
                      quality={100}
                    />
                  </Link>
                ) : (
                  <ImageOptimize
                    width={1312}
                    height={400}
                    src={flashSale?.customization?.banner}
                    alt={getTranslate(flashSale.name)}
                    priority={true}
                    quality={100}
                  />
                )}
              </div>
            ) : (
              ''
            )}

            <div className='listProduct container grid grid-cols-2 gap-3 pb-[80px]'>
              {flashSale &&
                flashSale.products.map((item: Product) => {
                  return (
                    <ProductCard
                      product={item}
                      type='flashSale'
                      layout={2}
                      className=''
                      key={item._id}
                    />
                  )
                })}
            </div>
          </>
        ) : (
          <div className='mb-[120px] pt-[15vh] max-w-[240px] mx-auto flex flex-col items-center justify-center'>
            <NotFoundItem
              label={`${
                systemConfig?.websiteWarehouseBrandName || ''
              } chưa có sản phẩm phù hợp với yêu cầu của bạn`}
            />
          </div>
        )}
      </section>
    </Main>
  )
}

export default FlashSalePage

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req, res, query } = context
  const { token, language, messages } = await setContext(
    getCookies({ req, res }),
    {
      language: context.locale,
    }
  )
  const params: string = query?.viewAt ? (query?.viewAt as string) : ''

  const [flashSale, regions] = await Promise.all([
    getFlashSaleSSR(params),
    getSaleRegion(),
  ])
  return {
    props: {
      messages,
      flashSale,
      regions,
      language,
      token: token || null,
    },
  }
}
